import uniAdminApi from "./api";

const universityService = {
  getMyUniversity: async () => {
    const res = await uniAdminApi.get("/university-admin/university/me");
    return res.data;
  },

  updateLoginPolicy: async (data) => {
    const res = await uniAdminApi.put("/university-admin/university/me/login-policy", data);
    return res.data;
  },

  updateLogo: async (photoId) => {
    const res = await uniAdminApi.put("/university-admin/university/me/logo", { photoId });
    return res.data;
  },

  getStaffAdmins: async (page = 0, size = 10) => {
    const res = await uniAdminApi.get("/university-admin/staff/admins", {
      params: { page, size },
    });
    return res.data;
  },

  createStaffAdmin: async (data) => {
    const res = await uniAdminApi.post("/university-admin/staff/admins", data);
    return res.data;
  },

  getAuditLogs: async (from, to, page = 0, size = 20) => {
    const res = await uniAdminApi.get("/university-admin/audit-log", {
      params: { from, to, page, size },
    });
    return res.data;
  },
};

export default universityService;
